import React from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Container,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormText
} from "reactstrap";
import NotificationSystem from "react-notification-system";

import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { commonService } from "../../_services";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import SelectListComponent from "../utils/selectList";

import FTPCredentialsTable from "./ftp-credentials-table";

//Icons
import AddIcon from "react-icons/lib/md/library-add";
import FTPCredentialIcon from "react-icons/lib/md/card-membership";

import { appHelpers, store } from "../../_helpers";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class FTPCredentialsViewContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ftpCredentials: [],
      // formattedAirlines: [],
      modal: false,
      modalClass: "",
      //ftp credentials form
      credentialId: false,
      airlineId: "",
      airlineCode: "",
      airline: "",
      username: "",
      password: "",
      retypePassword: "",
      serverAddress: "",
      port: "",
      airlines: [],
      //   emailAddress: "",

      //page error
      contentError: false, //Errors that affect content on the page
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      // pagination params
      pageSize: 10,
      currentPage: 1,
      totalCredentialCount: 0,

      // Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      createFTPEntityTypeId: null,
      deleteFTPEntityTypeId: null
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;

    this.interpreteAirlines = this.interpreteAirlines.bind(this);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { ftpCredentials, airlinesCarriers, entities } = reduxState;
    const { dispatch } = this.props;
    if (airlinesCarriers) {
      this.setState({ airlines: airlinesCarriers.Results });
    } else {
      this.fetchAirlines();
    }
    if (ftpCredentials) {
      this.setState({ ftpCredentials: ftpCredentials.Results });
    } else {
      this.fetchFTPCredentials();
    }
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }
    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  setEntityTypes = entities => {
    let createFTPEntityTypeId;
    let deleteFTPEntityTypeId;

    entities.forEach(entity => {
      if (
        entity.EntityType === appConstants.APP_ENTITIES.CREATE_FTP_CREDENTIAL
      ) {
        createFTPEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.DELETE_FTP_CREDENTIAL
      ) {
        deleteFTPEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ createFTPEntityTypeId, deleteFTPEntityTypeId });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.airline === "") {
      _errs_["airline"] = "Please select airline";
      formValid = false;
    }
    if (this.state.username === "") {
      _errs_["username"] = "Please enter username";
      formValid = false;
    }
    if (this.state.password === "") {
      _errs_["password"] = "Please enter password";
      formValid = false;
    }
    if (this.state.retypePassword === "") {
      _errs_["retypePassword"] = "Please retype password";
      formValid = false;
    }

    if (
      this.state.retypePassword !== "" &&
      this.state.password !== this.state.retypePassword
    ) {
      _errs_["retypePassword"] = "Doesn't match with password";
      formValid = false;
    }
    if (this.state.serverAddress === "") {
      _errs_["serverAddress"] = "Please enter server address";
      formValid = false;
    }
    if (this.state.port === "") {
      _errs_["port"] = "Please enter port number";
      formValid = false;
    }
    // if (this.state.emailAddress === "") {
    //   _errs_["emailAddress"] = "Please enter email address";
    //   formValid = false;
    // }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      credentialId: false,
      airlineId: "",
      airlineCode: "",
      airline: "",
      username: "",
      password: "",
      retypePassword: "",
      serverAddress: "",
      port: "",
      emailAddress: ""
    });
    this.resetError();
  }

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      // Id: 1,
      AirlineCode: this.state.airline,
      Username: this.state.username,
      Password: this.state.password,
      Port: this.state.port,
      ServerAddress: this.state.serverAddress
    };

    // dispatch(commonActions.manageFTPCredential(payload)).then(res => {
    //   if (res.status === appConstants.SUCCESS_RESPONSE) {
    //     this.toggle(null, "modalSlide");
    //     let msg = "FTP Credential created successfully";
    //     this.notify(msg, appConstants.NOTIFY_SUCCESS);
    //     this.fetchFTPCredentials();
    //   } else if (res.status === appConstants.ERROR_RESPONSE) {
    //     dispatch(alertActions.error(res.response));
    //     dispatch(apiActions.endRequest());
    //   }
    // });

    if (userRole === appConstants.ROLES.SUPER_ADMIN) {
      this.createFTPCredential(payload);
    } else {
      this.createMakerChecker(payload);
    }
  };

  createFTPCredential = payload => {
    const { dispatch } = this.props;

    dispatch(commonActions.manageFTPCredential(payload)).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = "FTP Credential created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        this.fetchFTPCredentials();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = payload => {
    const { authentication } = store.getState();
    const { dispatch } = this.props;
    let { createFTPEntityTypeId, airlines } = this.state;

    /* Maker Checker */
    let payloadTemplate = {
      Username: this.state.username,
      Port: this.state.port,
      ServerAddress: this.state.serverAddress
    };

    let airlineCode = this.state.airline;

    let airlineName = airlines.find(item => airlineCode === item.Code);
    // console.log({ airlineName });
    airlineName = airlineName ? airlineName.Name : "Unknown";
    // console.log({ airlineName });
    payloadTemplate.Airline = airlineName;

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${appConstants.PAS_URL}/api/FtpCredential/Save`,
      EntityTypeId: createFTPEntityTypeId,
      CreatedBy: authentication.user.userName
    };
    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = "FTP credential creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchFTPCredentials = pageNumber => {
    const { dispatch } = this.props;
    let { pageSize } = this.state;
    // dispatch(apiActions.startRequest());

    let fromPage = pageSize * (pageNumber - 1);

    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      pageNumber = 1;
    } else {
      dispatch(apiActions.startRequest());
    }

    commonService.getFTPCredentials(pageSize, fromPage).then(
      response => {
        this.setState({
          ftpCredentials: response.data.Results,
          totalCredentialCount: response.data.TotalCount,
          currentPage: pageNumber
        });
        dispatch(apiActions.endRequest());
      },
      error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
      }
    );
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch } = this.props;
    dispatch(apiActions.startRequest());
    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        this.setState({ airlines: airlinesCarriers.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  deleteFTPCredential = item => {
    const userRole = appHelpers.getActiveUser().AviRole;
    let payload = {
      // Id: 1,
      AirlineCode: item.AirlineCode,
      Username: item.Username,
      Port: item.Port,
      ServerAddress: item.ServerAddress
    };
    const { dispatch } = this.props;

    if (userRole !== appConstants.ROLES.SUPER_ADMIN) {
      this.createDeleteMakerChecker(item, payload);
    } else {
      commonService.deleteFTPCredential(item.Id).then(
        response => {
          let deleteStatus = response.response.data.Deleted;
          if (deleteStatus) {
            let msg = "FTP Credential deleted successfully";
            this.notify(msg, appConstants.NOTIFY_SUCCESS);
            this.fetchFTPCredentials();
          }
          dispatch(apiActions.endRequest());
        },
        error => {
          let errorMessage = appHelpers.interpretErrorResponse(error);
          this.notify(errorMessage, appConstants.NOTIFY_ERROR);
          dispatch(apiActions.endRequest());
        }
      );
    }
  };

  createDeleteMakerChecker = (item, payload) => {
    let { deleteFTPEntityTypeId, airlines } = this.state;
    const { authentication } = store.getState();
    const { dispatch } = this.props;

    let airlineCode = item.AirlineCode;
    /* Maker Checker */
    let payloadTemplate = {
      Username: item.Username,
      Port: item.Port,
      ServerAddress: item.ServerAddress
    };

    let airlineName = airlines.find(item => airlineCode === item.Code);
    airlineName = airlineName ? airlineName.Name : "Unknown";
    payloadTemplate.Airline = airlineName;

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      payloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: appConstants.PAS_URL + "/api/FtpCredential/Delete?id=" + item.Id,
      EntityTypeId: deleteFTPEntityTypeId,
      CreatedBy: authentication.user.userName
    };

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let msg = "Airline Deletion sent successfully";

        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };
  //   deleteFTPCredential = credentialId => {
  //     console.log('credentialId', credentialId)
  //     let { deleteFTPEntityTypeId} = this.state;
  //     const { authentication } = store.getState();
  //     let payload = {
  //       // Id: 1,
  //       AirlineCode: this.state.airline,
  //       Username: this.state.username,
  //       Port: this.state.port,
  //       ServerAddress: this.state.serverAddress
  //     };
  //     const { dispatch } = this.props;
  //     /* Maker Checker */
  //     let payloadTemplate = {
  //       Airline: this.state.airline,
  //       Username: this.state.username,
  //       Port: this.state.port,
  //       ServerAddress: this.state.serverAddress
  //     };
  //
  //     let makerCheckerPayload = {
  //       AppId: appConstants.MAKER_CHECKER_APP_ID,
  //       Payload: JSON.stringify(payload),
  //       payloadViewTemplate: JSON.stringify(payloadTemplate),
  //       URL: appConstants.PAS_URL + '/api/FtpCredential/Delete?id=' + credentialId,
  //       EntityTypeId: deleteFTPEntityTypeId,
  //       CreatedBy: authentication.user.userName
  //     };
  // console.log('makerCheckerPayload', makerCheckerPayload);
  //    // dispatch(apiActions.startRequest());
  //     // commonService.createMakerChecker(makerCheckerPayload)
  //     //     .then(res => {
  //     //       if(res.status === appConstants.SUCCESS_RESPONSE) {
  //     //         let msg = 'Airline Deletion sent successfully';
  //     //
  //     //         this.notify(msg, appConstants.NOTIFY_SUCCESS);
  //     //         dispatch(apiActions.endRequest());
  //     //       }
  //     //       else if(res.status === appConstants.ERROR_RESPONSE){
  //     //         dispatch(alertActions.error(res.response));
  //     //         dispatch(apiActions.endRequest());
  //     //       }
  //     //     })
  //     // commonService.deleteFTPCredential(credentialId).then(
  //     //   response => {
  //     //     let deleteStatus = response.response.data.Deleted;
  //     //     if (deleteStatus) {
  //     //       let msg = "FTP Credential deleted successfully";
  //     //       this.notify(msg, appConstants.NOTIFY_SUCCESS);
  //     //       this.fetchFTPCredentials();
  //     //     }
  //     //     dispatch(apiActions.endRequest());
  //     //   },
  //     //   error => {
  //     //     let errorMessage = appHelpers.interpretErrorResponse(error);
  //     //     this.notify(errorMessage, appConstants.NOTIFY_ERROR);
  //     //     dispatch(apiActions.endRequest());
  //     //   }
  //     // );
  //   };

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  interpreteAirlines(airlineCode) {
    let airlines = this.state.airlines;
    const totalAirlines = airlines.length;

    for (let i = 0; i < totalAirlines; i++) {
      if (airlines[i].Code === airlineCode) {
        return airlines[i].Name;
      }
    }
  }

  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting } = this.props;
    const { pageRequesting } = this.props;

    const {
      contentError,
      ftpCredentials,
      airlines,
      componentErrorMessages,
      pageSize,
      currentPage,
      totalCredentialCount
    } = this.state;

    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    FTP Credentials
                    <FormText color="muted">
                      <FTPCredentialIcon size="18" color="#43a8df" />{" "}
                      {totalCredentialCount} records
                    </FormText>
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      disabled={pageRequesting || requesting}
                      onClick={e => this.toggle(e, "modalSlideIn")}
                    >
                      <AddIcon color="#ffffff" size="20" />
                      &nbsp;Create Credentials
                    </Button>{" "}
                  </div>
                </div>

                {!pageRequesting && (
                  <FTPCredentialsTable
                    currentPage={currentPage}
                    pageDataCallback={this.fetchFTPCredentials}
                    data={ftpCredentials}
                    pageSize={pageSize}
                    totalCredentialCount={totalCredentialCount}
                    interpreteAirlines={this.interpreteAirlines}
                    deleteCallback={this.deleteFTPCredential}
                  />
                )}

                <Modal
                  size={"md"}
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.state.modalClass}
                >
                  <ModalHeader toggle={this.toggle}>
                    Create FTP Credential
                  </ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}
                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.airline
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airline</Label>

                              <SelectListComponent
                                placeholder={"Select airline..."}
                                data={airlines}
                                valueKey="Code"
                                textField="Name"
                                selectValue={this.state.airline}
                                onValueChange={payload =>
                                  this.handleSelectChange(
                                    payload,
                                    "Code",
                                    "airline"
                                  )
                                }
                              />

                              {componentErrorMessages.airline && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.airline}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>

                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.username
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Username</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.username}
                                onChange={event =>
                                  this.handleChange(event, "username")
                                }
                              />
                              {componentErrorMessages.username && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.username}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.password
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Password</Label>
                              <Input
                                type="password"
                                placeholder=""
                                value={this.state.password}
                                onChange={event =>
                                  this.handleChange(event, "password")
                                }
                              />
                              {componentErrorMessages.password && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.password}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>

                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .retypePassword
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Retype Password</Label>
                              <Input
                                type="password"
                                placeholder=""
                                value={this.state.retypePassword}
                                onChange={event =>
                                  this.handleChange(event, "retypePassword")
                                }
                              />
                              {componentErrorMessages.retypePassword && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.retypePassword}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.serverAddress
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Server Address</Label>
                              <Input
                                type="text"
                                placeholder=""
                                value={this.state.serverAddress}
                                onChange={event =>
                                  this.handleChange(event, "serverAddress")
                                }
                              />
                              {componentErrorMessages.serverAddress && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.serverAddress}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>

                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.port
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Port</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.port}
                                onChange={event =>
                                  this.handleChange(event, "port")
                                }
                              />
                              {componentErrorMessages.port && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.port}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>

                  {requesting && <div className={"loading-dot active"} />}
                </Modal>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert, ftpCredentials, airlinesCarriers, entities } = state;
  return {
    loggingIn,
    airlinesCarriers,
    requesting,
    pageRequesting,
    modal,
    alert,
    ftpCredentials,
    entities
  };
}
export default connect(mapStateToProps)(FTPCredentialsViewContent);



// WEBPACK FOOTER //
// ./src/views/ftp-credentials/view-content.js